import { useEffect } from 'react';
import { requireAuth } from '../utils/auth';
import AdminSidebar from '../components/admin/AdminSidebar';
import AdminHeader from '../components/admin/AdminHeader';
import AdminStats from '../components/admin/AdminStats';
import '../styles/admin.css';

export default function AdminDashboard() {
  useEffect(() => {
    requireAuth();
  }, []);

  return (
    <div className="admin-layout">
      <AdminSidebar />
      <div className="admin-content">
        <AdminHeader 
          title="Tableau de bord" 
          subtitle="Bienvenue dans l'administration DigitalPro"
        />
        <AdminStats />
      </div>
    </div>
  );
}